
import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft, Home } from 'lucide-react';
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbSeparator } from '@/components/ui/breadcrumb';

interface PollsHeaderProps {
  countryName?: string;
  currentIndex?: number;
  totalPolls?: number;
  onRefresh?: () => void;
}

const PollsHeader: React.FC<PollsHeaderProps> = ({ 
  countryName, 
  currentIndex, 
  totalPolls, 
  onRefresh 
}) => {
  return (
    <div className="mb-6">
      {/* Breadcrumbs */}
      <div className="mb-4">
        <Breadcrumb>
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbLink asChild>
                <Link to="/" className="text-muted-foreground hover:text-foreground">
                  <Home className="h-4 w-4 mr-1 inline" />
                  Home
                </Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
            {countryName && (
              <>
                <BreadcrumbSeparator />
                <BreadcrumbItem>
                  <BreadcrumbLink asChild>
                    <Link to="/countries" className="text-muted-foreground hover:text-foreground">
                      Countries
                    </Link>
                  </BreadcrumbLink>
                </BreadcrumbItem>
                <BreadcrumbSeparator />
                <BreadcrumbItem>
                  <BreadcrumbLink asChild>
                    <Link 
                      to={`/cards/${countryName?.toLowerCase()}`} 
                      className="text-muted-foreground hover:text-foreground"
                    >
                      {countryName}
                    </Link>
                  </BreadcrumbLink>
                </BreadcrumbItem>
              </>
            )}
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <span className="font-medium text-foreground">Polls</span>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>
      </div>

      {/* Back Link */}
      <Link 
        to="/" 
        className="inline-flex items-center text-muted-foreground hover:text-foreground transition-colors mb-4"
      >
        <ChevronLeft className="h-4 w-4 mr-1" />
        Back to Home
      </Link>

      {/* Poll Count Display (if applicable) */}
      {currentIndex !== undefined && totalPolls !== undefined && (
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-medium">
            Poll {currentIndex + 1} of {totalPolls}
          </h2>
          {onRefresh && (
            <button 
              onClick={onRefresh}
              className="text-sm text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300"
            >
              Refresh
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default PollsHeader;
